import { type ProcessedOption } from "@/components/site-builder/modules/CustomFormModule/types";
import { type FormBuilderFieldOption } from "@/types/form-builder";

export function flattenOptions(
  options: FormBuilderFieldOption[],
): ProcessedOption[] {
  const result: ProcessedOption[] = [];

  options.forEach((option) => {
    result.push({
      ...option,
      isSelectable: !!option.selectable,
      isHeading: false,
      isShown: true,
      level: 0,
    });

    if (option.options?.length) {
      result.push(
        ...flattenOptions(option.options).map((childOpt) => ({
          ...childOpt,
          level: 0,
        })),
      );
    }
  });

  return result;
}
